import { Component, OnInit, Input } from '@angular/core';
import { TerminalOverviewReport } from '../terminal-overview-report.type';
import { Zone } from '../../share/zones/zone.model';

@Component({
  selector: '[app-terminal-overview-report-partial]',
  templateUrl: './terminal-overview-report-partial.component.html',
  styleUrls: ['./terminal-overview-report-partial.component.css']
})
export class TerminalOverviewReportPartialComponent implements OnInit {

  @Input() terminalOverviewReportPartial: TerminalOverviewReport;
  @Input() zones: Zone[];
  constructor() { }

  ngOnInit() {
  }

  getZoneName(zoneId) {
    return this.zones.find(item => item.zoneId === zoneId).name;
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-overview-report/terminal-overview-report-partial/terminal-overview-report-partial.component.ts